import { useMutation, useQuery } from '@tanstack/react-query'
import { listEvents, changeEventStatus, createNewEvent, deleteEvent, updateEvent, getEvent, createNewEventInvitationBulk, cancelEventInvitation, createNewEventInvitation, getEventInvitationList, getEventRecordingList } from '../api/events'

export const useListEventsQuery = (queryParams = '') => {
    return useQuery({
      queryKey: ['events', queryParams],
      queryFn: () => listEvents(queryParams),
    });
};

export const useGetEventQuery = (queryParams = '', entity) => {
  return useQuery({
    queryKey: ['event', queryParams],
    queryFn: () => getEvent(queryParams),
    enabled: entity === 'event' && !!queryParams
  });
};

export const useAddNewEvent = () => {
    return useMutation({
      mutationFn: createNewEvent
    })
};

export const useChangeEventStatus = () => {
    return useMutation({
      mutationFn: changeEventStatus
    })
};

export const useUpdateEvent = () => {
  return useMutation({
    mutationFn: updateEvent
  })
};

export const useDeleteEvent = () => {
  return useMutation({
    mutationFn: deleteEvent
  })
};

// Event Invitation Part
export const useEventInvitationListQuery = (queryParams = '') => {
  return useQuery({
    queryKey: ['invitation_list', queryParams],
    queryFn: () => getEventInvitationList(queryParams),
    enabled: !!queryParams
  });
};

export const useAddNewEventInvitation = () => {
  return useMutation({
    mutationFn: createNewEventInvitation
  })
};

export const useCancelEventInvitation = () => {
  return useMutation({
    mutationFn: cancelEventInvitation
  })
};

export const useAddNewEventInvitationBulk = () => {
  return useMutation({
    mutationFn: createNewEventInvitationBulk
  })
};

// Recording
export const useEventRecordingListQuery = (queryParams = '') => {
  return useQuery({
    queryKey: ['recording_list', queryParams],
    queryFn: () => getEventRecordingList(queryParams),
    enabled: !!queryParams
  });
};